export interface AppVersionManifest {
  version: string;
  requiredUpdate?: boolean;
  minVersion?: string;
  releaseNotes?: string;
  buildTimestamp?: string;
  buildGitHash?: string;
  buildGitBranch?: string;
  baseVersion?: string;
  environment?: string;
}

export function parseAppVersionManifest(json: unknown): AppVersionManifest | null {
  if (!json || typeof json !== "object") return null;
  const o = json as Record<string, unknown>;
  if (typeof o.version !== "string" || o.version.length === 0) return null;

  return {
    version: o.version,
    requiredUpdate: typeof o.requiredUpdate === "boolean" ? o.requiredUpdate : undefined,
    minVersion: typeof o.minVersion === "string" ? o.minVersion : undefined,
    releaseNotes: typeof o.releaseNotes === "string" ? o.releaseNotes : undefined,
    buildTimestamp: typeof o.buildTimestamp === "string" ? o.buildTimestamp : undefined,
    buildGitHash: typeof o.buildGitHash === "string" ? o.buildGitHash : undefined,
    buildGitBranch: typeof o.buildGitBranch === "string" ? o.buildGitBranch : undefined,
    baseVersion: typeof o.baseVersion === "string" ? o.baseVersion : undefined,
    environment: typeof o.environment === "string" ? o.environment : undefined,
  };
}

export async function fetchAppVersionManifest(): Promise<AppVersionManifest> {
  const url = `${window.location.origin}/version.json?t=${Date.now()}`;
  const res = await fetch(url, { cache: "no-store" });
  if (!res.ok) {
    throw new Error(`Failed to load version manifest: ${res.status}`);
  }
  const body: unknown = await res.json();
  const parsed = parseAppVersionManifest(body);
  if (!parsed) {
    throw new Error("Invalid version.json payload");
  }
  return parsed;
}
